import { toArray } from './utils/array';
import { FOCUS_ALLOW } from './constants';

var focusIsHidden = function focusIsHidden() {
  return document && toArray(document.querySelectorAll('[' + FOCUS_ALLOW + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};

export default focusIsHidden;


//////////////////
// WEBPACK FOOTER
// ../node_modules/focus-lock/dist/es2015/focusIsHidden.js
// module id = 736
// module chunks = 0